import MieszkancyLista from "../Mieszkancy/MieszkancyLista.js";
import WodaMieszkaniec from "./WodaMieszkaniec.js";

const WodaMieszkancy = props => {

    const { mieszkaniec, mieszkancy, setMieszkaniec, ulice, ulicaId, lokale, setUlicaId, udzialyKontaAkt, setEditDataOd, setEditDataDo, 
        grupaUdzial, setGrupaUdzial, users_w, setUser, grupy, wybraneGrupyUdzial, setWybraneGrupyUdzial, rodzajLokalu, setRodzajLokalu, 
        setAddGrupe, setWybranyOdczyt, state, bezdomni, wybranyMieszkaniec, odczyty, planowaneZuzycie, tablicaCzynsze_g, wybranyOdczyt, 
        grupy_g, rozliczenieWody, setLoaderOn} = props;

    return (
        <div className="woda-content-mieszkancy">
            <MieszkancyLista
                mieszkaniec={mieszkaniec}
                mieszkancy={mieszkancy}
                setMieszkaniec={setMieszkaniec}
                ulice={ulice}
                ulicaId={ulicaId}
                lokale={lokale}
                setUlicaId={setUlicaId}
                udzialyKontaAkt={udzialyKontaAkt}
                setEditDataOd={setEditDataOd}
                setEditDataDo={setEditDataDo}
                grupaUdzial={grupaUdzial}
                setGrupaUdzial={setGrupaUdzial}
                users_w={users_w}
                setUser={setUser}
                grupy={grupy}
                wybraneGrupyUdzial={wybraneGrupyUdzial}
                setWybraneGrupyUdzial={setWybraneGrupyUdzial}
                rodzajLokalu={rodzajLokalu}
                setRodzajLokalu={setRodzajLokalu}
                setAddGrupe={setAddGrupe}
                setWybranyOdczyt={setWybranyOdczyt}
                state={state}
                bezdomni={bezdomni}
                setLoaderOn={setLoaderOn}
            />
            <WodaMieszkaniec
                wybranyMieszkaniec={wybranyMieszkaniec}
                udzialyKontaAkt={udzialyKontaAkt}
                grupy={grupy}
                lokale={lokale}
                ulice={ulice}
                odczyty={odczyty}
                planowaneZuzycie={planowaneZuzycie}
                grupaUdzial={grupaUdzial}
                tablicaCzynsze_g={tablicaCzynsze_g}
                wybranyOdczyt={wybranyOdczyt}
                setWybranyOdczyt={setWybranyOdczyt}
                mieszkaniec={wybranyMieszkaniec}
                grupy_g={grupy_g}
                rozliczenieWody={rozliczenieWody}
            />
        </div>
    )
}

export default WodaMieszkancy;